import '../styles/NewHeader.css';
import AllSvg from './AllSvg';
import { useWindowWidth } from '../js/calculator';
import { useAuth } from '../js/login';

const GnbHeader = ({ lang, bg }) => {
	const { cookieState } = useAuth();

	const isMobile = useWindowWidth(true);

	return (
		<div
			id="nav2020-login"
			className={bg === 'dark' ? 'gnb-container-dark' : 'gnb-container'}
			style={{ backgroundColor: bg === 'dark' ? '#222222' : '#ffffff' }}
		>
			<a href="https://www.chosun.com/" style={{ height: '25px' }}>
				<AllSvg type="chosun-logo" bg={bg} />
			</a>
			{cookieState ? (
				<a
					href="//www.chosun.com/mypage/profile/"
					className="chosun-login-menu"
					style={{ textDecoration: 'none' }}
				>
					<AllSvg type={isMobile ? 'login-mobile-y' : 'login'} bg={bg} />
					<span
						className="chosun-login-text"
						style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}
					>
						{cookieState?.dn}
					</span>
				</a>
			) : (
				<a
					href={
						lang === 'en'
							? '//www.chosun.com/en/subscribe/signin/'
							: '//www.chosun.com/subscribe/signin/'
					}
					className="chosun-login-menu"
					style={{ textDecoration: 'none' }}
				>
					<AllSvg type={isMobile ? 'login-mobile' : 'login'} bg={bg} />
					<span
						className="chosun-login-text"
						style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}
					>
						{lang === 'en' ? 'Sign-in' : '로그인'}
					</span>
				</a>
			)}
		</div>
	);
};

export default GnbHeader;
